import * as React from "react";

const ValidationSuccessIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
                <circle fill="#FFF" cx="10.5" cy="12.5" r="7.5"/>
                <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm6.652 9.555-7.664 7.664a1.262 1.262 0 0 1-.886.366v.52l-.011-.52a1.262 1.262 0 0 1-.891-.383l-3.867-4.006a1.253 1.253 0 0 1 1.803-1.74l2.981 3.089 6.762-6.762c.236-.236.551-.367.886-.367a1.254 1.254 0 0 1 .887 2.14z" fill="#007C38" fill-rule="nonzero"/>
            </g>
        </svg>
    );
};

export default ValidationSuccessIcon;